/*
 * @Author: Fan
 * @Date: 2020-04-18 21:23:13
 * @description:
 * @LastEditors: Fan
 */
import { inputControlOptions } from "../../../../form/component-schema";
import { DisplayType, StaffSelectorSelectType, StaffSelectorValueType } from "../../../../form/src/common/component-schema/complex-control-options";
import { DataType } from "../../../../form/typings";
import i18n from "../../../i18n";
export default {
    $id: "departmentSelector",
    type: DataType.Object,
    $ref: inputControlOptions.$id,
    properties: {
        widgetType: {
            type: DataType.String,
            title: i18n.t('dataitem.ControlType').toString(),
        },
        dataItemType: {
            type: DataType.String,
            title: i18n.t('dataitem.DataItemType').toString(),
        },
        multi: {
            type: DataType.String,
            title: i18n.t('dataitem.Multi').toString(),
            default: "false",
        },
        deptVisible: {
            type: DataType.String,
            title: i18n.t('dataitem.OptionalType').toString(),
            default: StaffSelectorSelectType.Org,
        },
        defaultValue: {
            type: DataType.Array,
            title: i18n.t('dataitem.DefaultValue').toString(),
            default: [],
        },
        defaultValueType: {
            type: DataType.String,
            title: i18n.t('dataitem.DefaultValue').toString(),
            default: StaffSelectorValueType.None,
        },
        orgRoot: {
            type: DataType.Array,
            title: i18n.t('dataitem.OrgRootNode').toString(),
            default: [],
        },
        orgRootValueType: {
            type: DataType.String,
            title: i18n.t('dataitem.OrgRootNode').toString(),
            default: StaffSelectorValueType.None,
        },
        recursive: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.RecursivelyDisplay').toString(),
            default: true,
        },
        roles: {
            type: DataType.String,
            title: i18n.t('dataitem.RoleScope').toString(),
            default: "",
        },
        mappings: {
            type: DataType.String,
            title: i18n.t('dataitem.Mapping').toString(),
        },
        displayType: {
            type: DataType.String,
            title: "displayType",
            default: DisplayType.Tag,
        },
        dataLinkage: {
            type: DataType.String,
            title: i18n.t('dataitem.DataLinkage').toString(),
        },
        labelVisible: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.LabelVisible').toString(),
            default: true,
        },
        readonlyCondition: {
            type: DataType.String,
            title: i18n.t('dataitem.ReadonlyConditions').toString(),
        },
    },
};
